import * as React from "react"
import { Box, Link, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"


export default function LinkIconBlock({ url="", icon="up-right-from-square", linkProps={}, iconProps={}, children, ...props }) {
    return <>
        { url ? <Link href={url} target="_blank" {...linkProps} sx={{ cursor: "pointer", color: 'text.primary', ...linkProps?.sx }}>
            <Typography variant="caption">{children}</Typography>
            { !!icon && <IconSeeker icon={icon} {...iconProps} sx={{ mr: 0.5, margin: .5, color: 'primary.main', ...iconProps?.sx }}/> }
        </Link> : children }
    </>
}